import { useEffect } from "react";
import { connect } from "react-redux";
import { Element } from "react-scroll";
import useScreen from "../../providers/screen";
import Item from "./Item";
import { Row, ElementTitle } from "./style";

const Lists = ({ categories, theme }) => {
  const { screen } = useScreen();

  useEffect(() => {
    window.scrollTo(0, 3);
  }, []);

  return (
    <>
      {categories.map((category, index) => {
        var keyId = String(category?.id);

        return (
          <Element key={index} name={keyId}>
            <ElementTitle className="mb-2 mx-1" theme={theme}>
              {category?.name}
            </ElementTitle>
            <Row className={`row no-gutters ${!screen?.isDesktop && "px-1"}`}>
              {category?.products.map((pizza, index) => (
                <Item key={index} data={pizza} index={index} />
              ))}
            </Row>
          </Element>
        );
      })}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Lists);
